import { createFileRoute } from "@tanstack/react-router";
import { Mcp } from "@/routes/help/mcp";

export const Route = createFileRoute("/dashboard/help/mcp")({
	component: Mcp,
});
